var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-detail-base"},[_c('h1',[_vm._v(_vm._s(_vm.newsData.title))]),_vm._v(" "),_c('span',{staticClass:"news-datetime"},[_vm._v(_vm._s(_vm._f("formatDatetime")(_vm.newsData.opened_at)))]),_vm._v(" "),_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"news-body",domProps:{"innerHTML":_vm._s(_vm.newsData.content)}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99700db8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/News/NewsDetail.vue
// module id = null
// module chunks = 